import React from 'react';
import './Loading.css';

const Loading = ({ color, height, width }) => {
	return (
		<span
			className={
				color === 'green' ? 'loadingComponent green' : 'loadingComponent black'
			}
			style={{ height: height, width: width }}
		></span>
	);
};

export default Loading;
